import { API_URL, getAuthHeaders } from './config';

export const clubsService = {
    list: async () => {
        const res = await fetch(`${API_URL}/clubs`);
        if (!res.ok) throw new Error("Failed to fetch clubs");
        return res.json();
    },
    get: async (id: string) => {
        const res = await fetch(`${API_URL}/clubs/${id}`);
        if (!res.ok) throw new Error("Failed to fetch club");
        return res.json();
    },
    getCourts: async (clubId: string) => {
        const res = await fetch(`${API_URL}/clubs/${clubId}/courts`);
        if (!res.ok) throw new Error("Failed to fetch courts");
        return res.json();
    },
    claim: async (clubId: string, userId: string, proofUrl: string) => {
        const res = await fetch(`${API_URL}/clubs/${clubId}/claim`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ user_id: userId, proof_url: proofUrl })
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to submit claim");
        }
        return res.json();
    },
    submitRequest: async (data: any) => {
        const res = await fetch(`${API_URL}/clubs/requests`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to submit request");
        }
        return res.json();
    },
    listRequests: async () => {
        const res = await fetch(`${API_URL}/users/me/club-requests`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to fetch requests");
        return res.json();
    },
    create: async (data: any) => {
        const res = await fetch(`${API_URL}/admin/clubs`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to create club");
        }
        return res.json();
    },
    delete: async (id: string) => {
        const res = await fetch(`${API_URL}/admin/clubs/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to delete club");
        return res.json();
    },
    bulkDelete: async (ids: string[]) => {
        const res = await fetch(`${API_URL}/admin/clubs/bulk-delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ ids })
        });
        if (!res.ok) throw new Error("Failed to delete clubs");
        return res.json();
    },
    getReviews: async (clubId: string) => {
        const res = await fetch(`${API_URL}/clubs/${clubId}/reviews`);
        if (!res.ok) throw new Error("Failed to fetch reviews");
        return res.json();
    },
    postReview: async (clubId: string, data: { rating: number, comment?: string | null }) => {
        const res = await fetch(`${API_URL}/clubs/${clubId}/reviews`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to post review");
        }
        return res.json();
    },
    replyToReview: async (reviewId: string, replyText: string) => {
        const res = await fetch(`${API_URL}/clubs/reviews/${reviewId}/reply`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ reply_text: replyText })
        });
        if (!res.ok) throw new Error("Failed to reply to review");
        return res.json();
    },
    acknowledgeReview: async (reviewId: string) => {
        const res = await fetch(`${API_URL}/clubs/reviews/${reviewId}/acknowledge`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            }
        });
        if (!res.ok) throw new Error("Failed to acknowledge review");
        return res.json();
    },
    getManagementReviews: async () => {
        const res = await fetch(`${API_URL}/manager/clubs/reviews`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to fetch management reviews");
        return res.json();
    },
    checkin: async (clubId: string) => {
        const res = await fetch(`${API_URL}/clubs/${clubId}/checkin`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            }
        });
        if (!res.ok) throw new Error("Failed to check in");
        return res.json();
    },
    submitAffiliationRequest: async (data: any) => {
        const res = await fetch(`${API_URL}/clubs/affiliation/request`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to submit affiliation request");
        }
        return res.json();
    },
    getAffiliationStatus: async () => {
        const res = await fetch(`${API_URL}/clubs/affiliation/status`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to fetch affiliation status");
        return res.json();
    }
};
